<template>
  <a-modal style="text-align: center" width="800px" v-model:visible="props.visible" title="项目看板"
           @ok="handleOk" :footer="null" @cancel="emit('showProject',false)">
    <div>1111</div>
  </a-modal>
</template>

<script setup>
let props = defineProps({
  visible: {
    type: Boolean,
    default: false
  }
});
let emit = defineEmits(['showProject'])
const handleOk = (e) => {
  console.log(e);
  emit('showMap', false);
};
</script>
<style scoped lang="scss">

</style>
